import Tabs from './tabs.vue'
import Tab from './tab.vue'
import TabPanel from './tab-panel.vue'
import TabPanels from './tab-panels.vue'

Tabs.install = Vue => {
  Vue.component(Tabs.name, Tabs)
}

Tab.install = Vue => {
  Vue.component(Tab.name, Tab)
}

TabPanel.install = Vue => {
  Vue.component(TabPanel.name, TabPanel)
}

TabPanels.install = Vue => {
  Vue.component(TabPanels.name, TabPanels)
}

export {Tabs, Tab, TabPanel, TabPanels}



// WEBPACK FOOTER //
// ./src/components/tab/index.js